import React from 'react'
import { I18n } from 'react-redux-i18n'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { fetchCard } from '../../actions/remote_api'
import { withDetailPopup } from '../detailPopup'
import { renderClassToServiceMapping } from '../table'
import styled from 'styled-components'

const CardDetailPopup = ({ instance }) => {
  const { fields } = I18n.t('cardPage')
  return (
    <form className="form-horizontal">
      <div className="form-group">
        <label className="col-sm-4 control-label">{fields.code}</label>
        <div className="col-sm-8">
          <p className="form-control-static">{instance && instance.code}</p>
        </div>
      </div>
      <div className="form-group">
        <label className="col-sm-4 control-label">{fields.name}</label>
        <div className="col-sm-8">
          <p className="form-control-static">{instance && instance.name}</p>
        </div>
      </div>
      <div className="form-group">
        <label className="col-sm-4 control-label">
          {fields.classToServiceMapping}
        </label>
        <ClassToServiceMappingCol>
          {renderClassToServiceMapping(
            instance ? instance.classToServiceMapping : undefined,
          )}
        </ClassToServiceMappingCol>
      </div>
    </form>
  )
}

const ClassToServiceMappingCol = styled.div.attrs({ className: 'col-sm-8' })`
  margin-top: 8px;
`

let CardDetailPopupContainer = withDetailPopup(CardDetailPopup, () => ({
  header: I18n.t('cardPage.detail.header'),
}))

export default connect(
  (state) => ({ instance: get(state, 'fetch.card.single') }),
  { fetchInstance: fetchCard },
)(CardDetailPopupContainer)
